import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import ZonaCargando from '../alertas/zonaCargando';
import ModalUsarIA from '../../componentesEspeciales/crearEditar/modalUsarIA';
import ModalDesaprobar from '../../componentesEspeciales/serviciosAdmin/modalDesaprobar';
import ModalLlamarUsuario, { RESULTADO_CONFIG } from '../../componentesEspeciales/serviciosAdmin/modalLlamarUsuario';
import ModalWhatsapp from '../../componentesEspeciales/serviciosAdmin/modalWhatsapp';
import ModalCorreo from '../../componentesEspeciales/serviciosAdmin/modalCorreo';
import MapaUbicacionServicio from '../../componentesEspeciales/crearEditar/mapa';
import { slugify } from '../../funcionesDatos/Textos';
import { validarNoContacto, precioValido } from '../../funcionesDatos/validacionesCrearEditar';

const BADGE_ESTADO = {
    Borrador:      { bg: "rgba(var(--gris-suave-rgb), 0.1)", color: "var(--gris-suave)", label: "Borrador" },
    Revision:      { bg: "rgba(var(--amarillo-warning-rgb), 0.15)",  color: "var(--dorado-oscuro)", label: "En revisión" },
    Aprobado:      { bg: "rgba(var(--verde-bootstrap-rgb), 0.1)",   color: "var(--verde-bootstrap)", label: "Aprobado" },
    Desaprobado:   { bg: "rgba(var(--rojo-error-rgb), 0.1)",   color: "var(--rojo-error)", label: "Desaprobado" },
    ErrorRevision: { bg: "rgba(var(--rojo-error-rgb), 0.1)",   color: "var(--rojo-error)", label: "Error revisión" },
};

const TIPO_PAQUETE_COLOR = {
    "Básico":   { bg: "rgba(var(--azul-bootstrap-cta-rgb), 0.08)",  color: "var(--azul-bootstrap-cta)" },
    "Premium":  { bg: "rgba(var(--violeta-bootstrap-rgb), 0.1)",   color: "var(--violeta-bootstrap)" },
    "Avanzado": { bg: "rgba(var(--naranja-mapa-rgb), 0.1)",   color: "var(--naranja-mapa)" },
};

function fmtPrecio(n) {
    if (!n && n !== 0) return "—";
    return "$" + new Intl.NumberFormat("es-CO").format(n);
}

function fmtFecha(f) {
    if (!f) return "—";
    return new Date(f).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" });
}

function val(v) { return v && v !== "NA" ? v : null; }

function ServicioAdminIndividual() {
    const navigate = useNavigate();
    const location = useLocation();
    const [{ idServicio }] = useState(() => {
        if (location.state?.params) return location.state.params;
        try {
            const stored = localStorage.getItem("admin_nav_servicio");
            if (stored) { localStorage.removeItem("admin_nav_servicio"); return JSON.parse(stored); }
        } catch {}
        return {};
    });
    const { usuario } = useOutletContext() || {};
    const puedeEditar = usuario?.tipo === "SuperAdmin" || usuario?.tipo === "Soporte" || usuario?.tipo === "Administrador";

    const [cargando, setCargando]         = useState(false);
    const [servicio, setServicio]         = useState(null);
    const [proveedor, setProveedor]       = useState(null);
    const [valoraciones, setValoraciones] = useState([]);
    const [promedio, setPromedio]         = useState(null);
    const [imgActiva, setImgActiva]       = useState(0);
    const [imagenExpandida, setImagenExpandida] = useState(null);
    const [llamadaIntentos,  setLlamadaIntentos]       = useState(0);
    const [llamadaResultado, setLlamadaResultado]     = useState("");
    const [llamadaNota,      setLlamadaNota]           = useState("");
    const [marcandoLlamada,  setMarcandoLlamada]      = useState(false);
    const [mostrarModalLlamada, setMostrarModalLlamada] = useState(false);
    const [mostrarModalWhatsapp, setMostrarModalWhatsapp] = useState(false);
    const [eliminando, setEliminando] = useState(false);

    // Estados para edición (solo Borrador + SuperAdmin)
    const [formEdit, setFormEdit]                   = useState({ titulo: "", descripcion: "" });
    const [paquetesEdit, setPaquetesEdit]           = useState([]);
    const [faqEdit, setFaqEdit]                     = useState([]);
    const [guardando, setGuardando]                 = useState(false);
    const [publicando, setPublicando]               = useState(false);
    const [tipoServicioEdit, setTipoServicioEdit]               = useState("Nodefinido");
    const [tipoDesplazamientoEdit, setTipoDesplazamientoEdit]   = useState("Nodefinido");
    const [servicioUrgenteEdit, setServicioUrgenteEdit]         = useState(false);
    // Paso 2
    const [cateConfig, setCateConfig]                           = useState([]);
    const [categoriaEdit, setCategoriaEdit]                     = useState("");
    const [subCategoriaEdit, setSubCategoriaEdit]               = useState("");
    const [zonas, setZonas]                                     = useState([]);
    const [zonaEdit, setZonaEdit]                               = useState("");
    const [ciudadesEdit, setCiudadesEdit]                       = useState([]);
    const [ciudadEdit, setCiudadEdit]                           = useState("");
    const [subZonaTipoEdit, setSubZonaTipoEdit]                 = useState("");
    const [subZonasPorCiudadEdit, setSubZonasPorCiudadEdit]     = useState({});
    const [subzonasEdit, setSubzonasEdit]                       = useState([]);
    const [coberturaEdit, setCoberturaEdit]                     = useState(false);
    const [direccionEdit, setDireccionEdit]                     = useState("");
    const [referenciaEdit, setReferenciaEdit]                   = useState("");
    const [latitudEdit, setLatitudEdit]                         = useState(null);
    const [longitudEdit, setLongitudEdit]                       = useState(null);
    // Paso 3
    const [imagenesAdminUI, setImagenesAdminUI]                 = useState(Array(8).fill({ preview: null, subiendo: false }));
    // Paso 4
    const [paqueteActivoEdit, setPaqueteActivoEdit]             = useState("Básico");
    const [cantidadPaquetesEdit, setCantidadPaquetesEdit]       = useState(1);

    useEffect(() => {
        if (!idServicio) {
            Swal.fire({ icon: "error", title: "Servicio no disponible", text: "No fue posible identificar el servicio.", confirmButtonColor: "var(--azul-logo-fondo)" });
            navigate(-1);
            return;
        }
        (async () => {
            try {
                setCargando(true);
                const res = await axios.post("/obtener-servicio-admin", { params: { idServicio } });
                if (!res.data.exito) {
                    Swal.fire({ icon: "error", title: "Error", text: res.data.mensaje || "No se pudo cargar el servicio.", confirmButtonColor: "var(--azul-logo-fondo)" });
                    return navigate(-1);
                }
                const srv = res.data.servicio;
                setServicio(srv);
                setLlamadaIntentos(srv.recordatorioEnviado?.telefonoIntentos  || 0);
                setLlamadaResultado(srv.recordatorioEnviado?.telefonoResultado || "");
                setLlamadaNota(srv.recordatorioEnviado?.telefonaNota           || "");
                setProveedor(res.data.proveedor);
                setValoraciones(res.data.valoraciones || []);
                setPromedio(res.data.promedio);
                // Inicializar form edición
                setFormEdit({ titulo: srv.nombre || "", descripcion: srv.descripcion || "" });
                const PAQUETE_VACIO = {
                    tipo: "Básico", descripcion: "", detalles: "", precio: "",
                    duracionCitaMin: "", diasSemana: [], unidadEntrega: "Horas",
                    diasEntrega: "", modoAgenda: "exacta", citasDia: "",
                    franjasDia: [], horariosDia: [], _original: null,
                };
                const TIPOS_ORDEN = ["Básico", "Premium", "Avanzado"];
                const paquetesDB = (srv.paquetes || []).length > 0
                    ? srv.paquetes.map((p, idx) => ({
                        tipo: TIPOS_ORDEN[idx] || p.tipo || "Básico",
                        descripcion: p.descripcion && p.descripcion !== "NA" ? p.descripcion : "",
                        detalles: Array.isArray(p.detalles) ? p.detalles.join("\n") : "",
                        precio: p.precio ?? "",
                        duracionCitaMin: p.duracionCitaMin ?? "",
                        diasSemana: Array.isArray(p.diasSemana) ? p.diasSemana : [],
                        unidadEntrega: p.unidadEntrega || "Horas",
                        diasEntrega: p.diasEntrega ?? "",
                        modoAgenda: p.modoAgenda || "exacta",
                        citasDia: p.citasDia ?? "",
                        franjasDia: Array.isArray(p.franjasDia) ? p.franjasDia : [],
                        horariosDia: Array.isArray(p.horariosDia) ? p.horariosDia : [],
                        _original: p,
                    }))
                    : [PAQUETE_VACIO];
                setPaquetesEdit(paquetesDB);
                setFaqEdit(
                    (srv.faq || []).length > 0
                        ? srv.faq.map(f => ({ pregunta: f.pregunta || "", respuesta: f.respuesta || "" }))
                        : [{ pregunta: "", respuesta: "" }]
                );
                setTipoServicioEdit(srv.tipoServicio || "Nodefinido");
                setTipoDesplazamientoEdit(srv.tipoDesplazamiento || "Nodefinido");
                setServicioUrgenteEdit(!!srv.urgente);
                // Paso 2
                setCategoriaEdit(srv.categoria && srv.categoria !== "NA" ? srv.categoria : "");
                setSubCategoriaEdit(srv.subcategoria && srv.subcategoria !== "NA" ? srv.subcategoria : "");
                setZonaEdit(srv.zona && srv.zona !== "NA" ? srv.zona : "");
                setCiudadEdit(srv.ciudad && srv.ciudad !== "NA" ? srv.ciudad : "");
                setSubzonasEdit(Array.isArray(srv.subzonas) ? srv.subzonas : []);
                setCoberturaEdit(Boolean(srv.coberturaCompletaCiudad));
                setDireccionEdit(srv.ubicacion?.direccionTexto || "");
                setReferenciaEdit(srv.ubicacion?.referencia || "");
                setLatitudEdit(srv.ubicacion?.latitud ?? null);
                setLongitudEdit(srv.ubicacion?.longitud ?? null);
                setImagenesAdminUI(Array(8).fill(null).map((_, i) => ({
                    preview: srv.imagenes?.[i] || null,
                    subiendo: false,
                })));
                setCantidadPaquetesEdit(Math.max(1, (srv.paquetes || []).length));
                // Cargar categorías
                try {
                    const resCat = await axios.post("/obtener-categorias");
                    setCateConfig(Array.isArray(resCat.data?.categoriasConfig) ? resCat.data.categoriasConfig : []);
                } catch { /* continúa sin categorías */ }
                // Cargar zonas
                try {
                    const resPais = await axios.post("/obtener-info-pais-total", { params: { pais: "Colombia" } });
                    const infoPais = resPais.data?.contenidoPais;
                    if (infoPais) {
                        const zonasPais = Array.isArray(infoPais.departamentos) ? infoPais.departamentos : [];
                        setZonas(zonasPais);
                        const zonaEnc = zonasPais.find(z => z?.departamento === srv.zona);
                        if (zonaEnc) {
                            setSubZonaTipoEdit(zonaEnc.subzonasTipo || "");
                            setSubZonasPorCiudadEdit(zonaEnc.subzonasPorCiudad || {});
                            setCiudadesEdit(Array.isArray(zonaEnc.ciudades) ? zonaEnc.ciudades : []);
                        }
                    }
                } catch { /* continúa sin zonas */ }
            } catch {
                Swal.fire({ icon: "error", title: "Error", text: "No se pudo cargar el servicio.", confirmButtonColor: "var(--azul-logo-fondo)" });
                navigate(-1);
            } finally {
                setCargando(false);
            }
        })();
    }, [idServicio, navigate]);

    function actualizarPaqueteEdit(tipo, campo, valor) {
        setPaquetesEdit(prev => prev.map(p => p.tipo === tipo ? { ...p, [campo]: valor } : p));
    }
    function actualizarTodosLosPaquetesEdit(campo, valor) {
        setPaquetesEdit(prev => prev.map(p => ({ ...p, [campo]: valor })));
    }
    function cambiarCantidadPaquetes(n) {
        const TIPOS = ["Básico", "Premium", "Avanzado"];
        setCantidadPaquetesEdit(n);
        setPaquetesEdit(prev => {
            const ref = prev[0] || {};
            let lista = [...prev];
            while (lista.length < n) {
                const tipo = TIPOS[lista.length];
                lista.push({
                    tipo, descripcion: "", detalles: "", precio: "", duracionCitaMin: "",
                    diasSemana: [...(ref.diasSemana || [])],
                    unidadEntrega: ref.unidadEntrega || "Horas",
                    diasEntrega: ref.diasEntrega || "",
                    modoAgenda: ref.modoAgenda || "exacta",
                    citasDia: ref.citasDia || "",
                    franjasDia: [...(ref.franjasDia || [])],
                    horariosDia: [...(ref.horariosDia || [])],
                    _original: { tipo },
                });
            }
            return lista.slice(0, n);
        });
        setPaqueteActivoEdit(prev => {
            const validos = TIPOS.slice(0, n);
            return validos.includes(prev) ? prev : "Básico";
        });
    }

    async function subirImagenAdmin(file, index) {
        if (!categoriaEdit || !subCategoriaEdit) {
            Swal.fire({ icon: 'warning', title: 'Categoría requerida', text: 'Selecciona una categoría y subcategoría antes de subir imágenes.', confirmButtonColor: "var(--azul-logo-fondo)" });
            return;
        }
        if (!proveedor?.username) return;
        if (file.size / (1024 * 1024) > 10) {
            Swal.fire({ icon: 'error', title: 'Imagen muy pesada', text: 'Máximo 10 MB por imagen.', confirmButtonColor: "var(--azul-logo-fondo)" });
            return;
        }
        await guardarEdicion({ silencioso: true });
        setImagenesAdminUI(prev => prev.map((x, i) => i === index ? { ...x, subiendo: true } : x));
        try {
            const formData = new FormData();
            formData.append("imagen", file);
            const res = await axios.post('/subida-imagenes-servicios', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                params: {
                    usuario: proveedor.username,
                    categoria: categoriaEdit || "general",
                    subcategoria: subCategoriaEdit || "general",
                    idServicio: servicio.idServicio,
                    numeroContenido: index,
                },
            });
            if (res.data?.url) {
                setImagenesAdminUI(prev => prev.map((x, i) => i === index ? { preview: res.data.url, subiendo: false } : x));
            } else {
                throw new Error("sin url");
            }
        } catch {
            Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo subir la imagen.', confirmButtonColor: "var(--azul-logo-fondo)" });
            setImagenesAdminUI(prev => prev.map((x, i) => i === index ? { ...x, subiendo: false } : x));
        }
    }

    async function guardarEdicion({ silencioso = false } = {}) {
        if (!proveedor?.username) return;
        try {
            setGuardando(true);
            const paquetesAenviar = paquetesEdit.map(p => ({
                ...p._original,
                tipo: p.tipo,
                descripcion: p.descripcion || "NA",
                detalles: p.detalles ? p.detalles.split("\n").map(l => l.trim()).filter(Boolean) : [],
                precio: Number(String(p.precio || "0").replace(/[^0-9.]/g, "")) || 0,
                duracionCitaMin: Number(p.duracionCitaMin) || null,
                diasSemana: p.diasSemana,
                unidadEntrega: p.unidadEntrega || "Horas",
                diasEntrega: p.diasEntrega || null,
                modoAgenda: p.modoAgenda || "exacta",
                citasDia: p.citasDia,
                franjasDia: p.franjasDia,
                horariosDia: p.horariosDia,
            }));
            const faqAenviar = faqEdit
                .filter(f => f.pregunta.trim())
                .map(f => ({ pregunta: f.pregunta, respuesta: f.respuesta }));

            const res = await axios.post("/guardar-progreso", {
                params: {
                    usuario: { username: proveedor.username },
                    idServicio: servicio.idServicio,
                    nombre: formEdit.titulo,
                    descripcion: formEdit.descripcion,
                    categoria: categoriaEdit,
                    subcategoria: subCategoriaEdit,
                    zona: zonaEdit,
                    ciudad: ciudadEdit,
                    subZonaTipo: subZonaTipoEdit,
                    subzonas: subzonasEdit,
                    coberturaCompletaCiudad: coberturaEdit,
                    pais: servicio.pais || "Colombia",
                    zonaHoraria: servicio.zonaHoraria,
                    tipoServicio: tipoServicioEdit,
                    tipoDesplazamiento: tipoServicioEdit === "Presencial" ? tipoDesplazamientoEdit : "NA",
                    urgente: tipoServicioEdit === "Presencial" ? servicioUrgenteEdit : false,
                    ubicacion: tipoServicioEdit === "Presencial" && tipoDesplazamientoEdit === "EnLocal"
                        ? { direccionTexto: direccionEdit, referencia: referenciaEdit, latitud: latitudEdit, longitud: longitudEdit, precision: "exacta" }
                        : servicio.ubicacion,
                    paquetes: paquetesAenviar,
                    faq: faqAenviar,
                },
            });
            if (res.data.exito) {
                if (!silencioso) {
                    Swal.fire({ icon: "success", title: "Guardado", text: "El servicio fue actualizado.", confirmButtonColor: "var(--azul-logo-fondo)", timer: 2000, showConfirmButton: false });
                }
                setServicio(prev => ({ ...prev, nombre: formEdit.titulo, descripcion: formEdit.descripcion }));
            } else {
                if (!silencioso) {
                    Swal.fire({ icon: "error", title: "Error", text: res.data.mensaje || "No se pudo guardar.", confirmButtonColor: "var(--azul-logo-fondo)" });
                }
            }
        } catch {
            if (!silencioso) {
                Swal.fire({ icon: "error", title: "Error", text: "Ocurrió un error al guardar.", confirmButtonColor: "var(--azul-logo-fondo)" });
            }
        } finally {
            setGuardando(false);
        }
    }

    async function publicarServicioAdmin() {
        const errores = [];

        // Paso 1 — tipo de servicio
        if (tipoServicioEdit !== "Digital" && tipoServicioEdit !== "Presencial") {
            errores.push("Debes seleccionar el tipo de servicio (Presencial o Digital).");
        }
        if (tipoServicioEdit === "Presencial" && tipoDesplazamientoEdit !== "Domicilio" && tipoDesplazamientoEdit !== "EnLocal") {
            errores.push("Debes seleccionar cómo se prestará el servicio (Domicilio o En local).");
        }

        // Paso 3 — mínimo 1 foto obligatoria
        const fotosSubidas = imagenesAdminUI.filter(img => typeof img?.preview === "string" && img.preview.trim() !== "");
        if (fotosSubidas.length < 1) {
            errores.push("Debes subir al menos 1 foto del servicio.");
        }

        // Paso 2 — título y descripción
        const titulo = String(formEdit.titulo || "").trim();
        const descripcion = String(formEdit.descripcion || "").trim();
        if (titulo.length < 5) errores.push("El título debe tener al menos 5 caracteres.");
        if (descripcion.length < 15) errores.push("La descripción debe tener al menos 15 caracteres.");
        validarNoContacto({ etiqueta: "Descripción del servicio", texto: descripcion, errores });

        // Paso 2 — categoría y subcategoría
        if (!categoriaEdit || categoriaEdit === "NA") errores.push("Debes seleccionar una categoría.");
        if (!subCategoriaEdit || subCategoriaEdit === "NA") errores.push("Debes seleccionar una subcategoría.");

        // Paso 2 — ubicación (solo Presencial)
        if (tipoServicioEdit === "Presencial") {
            const subzonasDisponiblesCiudad = Array.isArray(subZonasPorCiudadEdit?.[ciudadEdit]) ? subZonasPorCiudadEdit[ciudadEdit] : [];
            const ciudadTieneSubzonas = subzonasDisponiblesCiudad.length > 0;

            if (!zonaEdit || zonaEdit === "NA") errores.push("Debes seleccionar una zona (departamento).");
            if (!ciudadEdit || ciudadEdit === "NA") errores.push("Debes seleccionar una ciudad.");
            if (ciudadTieneSubzonas && !coberturaEdit && subzonasEdit.length < 1) {
                errores.push("Debes seleccionar al menos una subzona o indicar cobertura completa de la ciudad.");
            }
            if (tipoDesplazamientoEdit === "EnLocal") {
                if (!String(direccionEdit || "").trim()) errores.push("Debes escribir la dirección exacta del local.");
                if (!String(referenciaEdit || "").trim()) errores.push("Debes escribir una referencia del local.");
                if (latitudEdit === null || longitudEdit === null) errores.push("Debes marcar la ubicación exacta en el mapa.");
            }
        }

        // Paso 4 — validar cada paquete activo
        for (const p of paquetesEdit) {
            const nombre = p.tipo;
            const errsP = [];
            const dias = Array.isArray(p.diasSemana) ? p.diasSemana : [];
            if (dias.length === 0) errsP.push("selecciona los días de la semana");
            if (!precioValido(p.precio)) errsP.push("ingresa un precio válido mayor a 0");
            const desc = String(p.descripcion || "").trim();
            if (!desc || desc.length < 15) errsP.push("la descripción corta debe tener al menos 15 caracteres");
            const det = String(p.detalles || "").trim();
            if (!det || det.length < 10) errsP.push("el campo 'Lo que incluye' debe tener al menos 10 caracteres");
            validarNoContacto({ etiqueta: `Paquete ${nombre} - Descripción`, texto: desc, errores: errsP });
            validarNoContacto({ etiqueta: `Paquete ${nombre} - Incluye`, texto: det, errores: errsP });
            const unidad = p.unidadEntrega === "Horas" ? "Horas" : "Dias";
            if (unidad === "Dias") {
                const dEnt = Number(String(p.diasEntrega || "").replace(/[^0-9]/g, ""));
                if (!Number.isFinite(dEnt) || dEnt <= 0) errsP.push("ingresa cuántos días de entrega tiene el paquete");
            }
            if (unidad === "Horas") {
                const citas = Number(String(p.citasDia || "").replace(/[^0-9]/g, ""));
                const durMin = Number(String(p.duracionCitaMin || "").replace(/[^0-9]/g, ""));
                if (!Number.isFinite(citas) || citas <= 0) errsP.push("selecciona cuántos servicios haces en un día");
                if (!Number.isFinite(durMin) || durMin <= 0) errsP.push("ingresa cuánto dura cada servicio (min)");
                const modo = p.modoAgenda === "flexible" ? "flexible" : "exacta";
                if (modo === "exacta") {
                    const hor = Array.isArray(p.horariosDia) ? p.horariosDia : [];
                    if (hor.length < 1 || hor.length !== citas) errsP.push("configura todos los horarios exactos");
                    if (hor.some(h => !String(h || "").trim())) errsP.push("hay horarios exactos vacíos");
                } else {
                    const franjas = Array.isArray(p.franjasDia) ? p.franjasDia : [];
                    if (franjas.length === 0) errsP.push("selecciona al menos una franja (mañana/tarde/noche)");
                }
            }
            if (errsP.length > 0) errores.push(...errsP.map(e => `Paquete ${nombre}: ${e}.`));
        }

        // Paso 4 — urgente: doble seguro
        if (servicioUrgenteEdit && paquetesEdit.length > 0) {
            const ref = paquetesEdit[0];
            if ((ref.unidadEntrega || "Horas") === "Dias") {
                errores.push("El modo urgente no es compatible con servicios por días.");
            }
            if ((ref.modoAgenda || "exacta") === "flexible") {
                errores.push("El modo urgente no es compatible con horarios flexibles.");
            }
        }

        // Paso 5 — FAQ: al menos 1 pregunta válida
        const faqConPregunta = faqEdit.filter(f => String(f?.pregunta || "").trim());
        if (faqConPregunta.length < 1) {
            errores.push("Debes agregar al menos 1 pregunta en el FAQ.");
        } else {
            faqConPregunta.forEach((f, idx) => {
                const preg = String(f.pregunta || "").trim();
                const resp = String(f.respuesta || "").trim();
                if (preg.length < 10) errores.push(`FAQ ${idx + 1}: la pregunta debe tener al menos 10 caracteres.`);
                if (resp.length < 20) errores.push(`FAQ ${idx + 1}: la respuesta debe tener al menos 20 caracteres.`);
                validarNoContacto({ etiqueta: `FAQ ${idx + 1} - Pregunta`, texto: preg, errores });
                validarNoContacto({ etiqueta: `FAQ ${idx + 1} - Respuesta`, texto: resp, errores });
            });
        }

        // Mostrar todos los errores juntos
        if (errores.length > 0) {
            return Swal.fire({
                icon: "error",
                title: "Completa el servicio antes de publicar",
                html: `<div style="text-align:left;font-size:14px;line-height:1.6"><ul style="padding-left:18px;margin:0">${errores.map(e => `<li>${e}</li>`).join("")}</ul></div>`,
                confirmButtonText: "Entendido",
                confirmButtonColor: "var(--azul-logo-fondo)",
            });
        }

        // Validaciones pasadas — guardar primero, luego publicar
        try {
            setPublicando(true);

            // Guardar todos los datos actualizados
            const paquetesAenviar = paquetesEdit.map(p => ({
                ...p._original,
                tipo: p.tipo,
                descripcion: p.descripcion || "NA",
                detalles: p.detalles ? p.detalles.split("\n").map(l => l.trim()).filter(Boolean) : [],
                precio: Number(String(p.precio || "0").replace(/[^0-9.]/g, "")) || 0,
                duracionCitaMin: Number(p.duracionCitaMin) || null,
                diasSemana: p.diasSemana,
                unidadEntrega: p.unidadEntrega || "Horas",
                diasEntrega: p.diasEntrega || null,
                modoAgenda: p.modoAgenda || "exacta",
                citasDia: p.citasDia,
                franjasDia: p.franjasDia,
                horariosDia: p.horariosDia,
            }));
            const faqAenviar = faqEdit
                .filter(f => f.pregunta.trim())
                .map(f => ({ pregunta: f.pregunta, respuesta: f.respuesta }));

            const resSave = await axios.post("/guardar-progreso", {
                params: {
                    usuario: { username: proveedor.username },
                    idServicio: servicio.idServicio,
                    nombre: formEdit.titulo,
                    descripcion: formEdit.descripcion,
                    categoria: categoriaEdit,
                    subcategoria: subCategoriaEdit,
                    zona: zonaEdit,
                    ciudad: ciudadEdit,
                    subZonaTipo: subZonaTipoEdit,
                    subzonas: subzonasEdit,
                    coberturaCompletaCiudad: coberturaEdit,
                    pais: servicio.pais || "Colombia",
                    zonaHoraria: servicio.zonaHoraria,
                    tipoServicio: tipoServicioEdit,
                    tipoDesplazamiento: tipoServicioEdit === "Presencial" ? tipoDesplazamientoEdit : "NA",
                    urgente: tipoServicioEdit === "Presencial" ? servicioUrgenteEdit : false,
                    ubicacion: tipoServicioEdit === "Presencial" && tipoDesplazamientoEdit === "EnLocal"
                        ? { direccionTexto: direccionEdit, referencia: referenciaEdit, latitud: latitudEdit, longitud: longitudEdit, precision: "exacta" }
                        : servicio.ubicacion,
                    paquetes: paquetesAenviar,
                    faq: faqAenviar,
                },
            });
            if (!resSave.data.exito) {
                throw new Error(resSave.data.mensaje || "Error al guardar el servicio antes de publicar");
            }

            // Publicar
            await axios.post("/servicio-en-revision-aws", {
                params: { idServicio: servicio.idServicio, idUsuario: proveedor.idUsuario },
            });

            Swal.fire({ icon: "success", title: "¡Servicio publicado!", text: "El servicio fue puesto en revisión correctamente.", confirmButtonColor: "var(--azul-logo-fondo)" });
            setServicio(prev => ({ ...prev, estado: "Revision", nombre: formEdit.titulo, descripcion: formEdit.descripcion }));
        } catch (err) {
            Swal.fire({ icon: "error", title: "Error al publicar", text: err.message || "Ocurrió un error al publicar el servicio.", confirmButtonColor: "var(--azul-logo-fondo)" });
        } finally {
            setPublicando(false);
        }
    }

    async function eliminarServicio() {
        const confirm = await Swal.fire({
            icon: "warning",
            title: "¿Eliminar este servicio?",
            text: "Esta acción no se puede deshacer. El servicio será borrado permanentemente.",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "var(--rojo-error)",
        });
        if (!confirm.isConfirmed) return;
        try {
            setEliminando(true);
            const res = await axios.post("/eliminar-servicio", {
                params: { idServicio: servicio.idServicio, idVendedor: proveedor.idUsuario },
            });
            if (res.data?.eliminado === false) {
                return Swal.fire({ icon: "error", title: "No se puede eliminar", text: res.data?.mensaje || "El servicio tiene reservas activas.", confirmButtonColor: "var(--azul-logo-fondo)" });
            }
            await Swal.fire({ icon: "success", title: "Servicio eliminado", timer: 1400, showConfirmButton: false });
            navigate(-1);
        } catch {
            Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar el servicio.", confirmButtonColor: "var(--azul-logo-fondo)" });
        } finally {
            setEliminando(false);
        }
    }

    if (cargando) return <ZonaCargando />;
    if (!servicio) return null;

    const est    = BADGE_ESTADO[servicio.estado] || BADGE_ESTADO.Borrador;
    const imgs   = (servicio.imagenes || []).filter(Boolean);

    return (
        <div className="container-fluid pb-5">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-start pt-3 pb-2 mb-4 border-bottom">
                <div>
                    <div className="d-flex align-items-center gap-3 flex-wrap">
                        <h1 className="h2 text-dark mb-0">{servicio.nombre || "Servicio sin nombre"}</h1>
                        <span className="badge rounded-pill px-3 py-1" style={{ background: est.bg, color: est.color, fontSize: "0.8rem" }}>
                            {est.label}
                        </span>
                        {servicio.estado === "Borrador" && (() => {
                            const r = servicio.recordatorioEnviado || {};
                            const alguno = r.whatsapp || r.klaviyo || r.pushApp;
                            if (!alguno) return (
                                <span className="badge rounded-pill px-3 py-1" style={{ background: "rgba(var(--amarillo-warning-rgb), 0.15)", color: "var(--dorado-oscuro)", fontSize: "0.8rem" }}>
                                    <i className="bi bi-bell-slash me-1"></i>Sin notificar
                                </span>
                            );
                            return (
                                <span className="d-inline-flex gap-1 flex-wrap align-items-center">
                                    {r.whatsapp && (
                                        <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--verde-whatsapp-rgb), 0.12)", color: "var(--verde-azulado)", fontSize: "0.78rem" }}>
                                            <i className="bi bi-whatsapp me-1"></i>WhatsApp
                                        </span>
                                    )}
                                    {r.klaviyo && (
                                        <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--azul-bootstrap-cta-rgb), 0.1)", color: "var(--azul-bootstrap-cta)", fontSize: "0.78rem" }}>
                                            <i className="bi bi-envelope-fill me-1"></i>Email
                                        </span>
                                    )}
                                    {r.pushApp && (
                                        <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--violeta-bootstrap-rgb), 0.1)", color: "var(--violeta-bootstrap)", fontSize: "0.78rem" }}>
                                            <i className="bi bi-phone-fill me-1"></i>App
                                        </span>
                                    )}
                                </span>
                            );
                        })()}
                    </div>
                    <p className="text-muted small mb-0 mt-1" style={{ fontFamily: "monospace", fontSize: "0.72rem" }}>
                        ID: {servicio.idServicio}
                    </p>
                </div>
                <div className="d-flex gap-2 flex-shrink-0">
                    {servicio?.estado === "Desaprobado" && puedeEditar && (
                        <button
                            className="btn btn-outline-primary btn-sm rounded-3 fw-semibold"
                            onClick={async () => {
                                const result = await Swal.fire({
                                    icon: "warning",
                                    title: "¿Volver a borrador?",
                                    text: "El servicio volverá a estado Borrador y el vendedor podrá editarlo de nuevo.",
                                    showCancelButton: true,
                                    confirmButtonText: "Sí, mover a borrador",
                                    cancelButtonText: "Cancelar",
                                    confirmButtonColor: "var(--azul-logo-fondo)",
                                });
                                if (!result.isConfirmed) return;
                                try {
                                    const res = await axios.post("/cambiar-a-borrador", {
                                        params: { idServicio: servicio.idServicio, idVendedor: proveedor.idUsuario },
                                    });
                                    if (res.data?.modificado === false) {
                                        return Swal.fire({ icon: "error", title: "No se puede mover", text: res.data?.mensaje || "El servicio tiene reservas activas.", confirmButtonColor: "var(--azul-logo-fondo)" });
                                    }
                                    Swal.fire({ icon: "success", title: "Movido a borrador", timer: 1400, showConfirmButton: false });
                                    setServicio(prev => ({ ...prev, estado: "Borrador" }));
                                } catch {
                                    Swal.fire({ icon: "error", title: "Error", text: "No se pudo cambiar el estado.", confirmButtonColor: "var(--azul-logo-fondo)" });
                                }
                            }}
                        >
                            <i className="bi bi-arrow-counterclockwise me-1"></i>Cambiar a borrador
                        </button>
                    )}
                    {(servicio?.estado === "Aprobado" || servicio?.estado === "ErrorRevision") && (
                        <button
                            className="btn btn-outline-secondary btn-sm rounded-3 fw-semibold"
                            onClick={async () => {
                                const result = await Swal.fire({
                                    icon: "warning",
                                    title: "¿Volver a borrador?",
                                    text: "El servicio volverá a estado Borrador y el vendedor podrá editarlo. Si tiene reservas activas no se podrá mover.",
                                    showCancelButton: true,
                                    confirmButtonText: "Sí, mover a borrador",
                                    cancelButtonText: "Cancelar",
                                    confirmButtonColor: "var(--azul-logo-fondo)",
                                });
                                if (!result.isConfirmed) return;
                                try {
                                    const res = await axios.post("/cambiar-a-borrador", {
                                        params: { idServicio: servicio.idServicio, idVendedor: proveedor.idUsuario },
                                    });
                                    if (res.data?.modificado === false) {
                                        return Swal.fire({ icon: "error", title: "No se puede mover", text: res.data?.mensaje || "El servicio tiene reservas activas.", confirmButtonColor: "var(--azul-logo-fondo)" });
                                    }
                                    Swal.fire({ icon: "success", title: "Movido a borrador", timer: 1400, showConfirmButton: false });
                                    setServicio(prev => ({ ...prev, estado: "Borrador" }));
                                } catch {
                                    Swal.fire({ icon: "error", title: "Error", text: "No se pudo cambiar el estado.", confirmButtonColor: "var(--azul-logo-fondo)" });
                                }
                            }}
                        >
                            <i className="bi bi-pencil me-1"></i>Editar
                        </button>
                    )}
                    {servicio?.estado === "Aprobado" && (
                        <ModalDesaprobar
                            idServicio={servicio?.idServicio}
                            onDesaprobado={(razon) => setServicio(prev => ({ ...prev, estado: "Desaprobado", mensajeRevision: razon }))}
                        />
                    )}
                    {servicio?.estado === "Aprobado" && (
                    <button
                        className="btn btn-outline-secondary btn-sm rounded-3"
                        onClick={async () => {
                            const id     = servicio?.idServicio;
                            const nombre = (servicio?.nombre && servicio.nombre !== "NA") ? servicio.nombre : "servicio";
                            const slug   = await slugify(nombre) || "servicio";
                            const url    = window.location.origin + "/servicio/" + slug + "-" + id;
                            await navigator.clipboard.writeText(url);
                        }}
                        title="Copiar enlace del servicio"
                    >
                        <i className="bi bi-link-45deg me-1"></i>Ver servicio
                    </button>
                    )}
                    {(servicio?.estado === "Borrador" || servicio?.estado === "Desaprobado") && proveedor?.email && (
                        <ModalCorreo
                            idServicio={servicio?.idServicio}
                            proveedor={proveedor}
                            modo="recordatorio"
                            labelBoton="Correo"
                            iconoBoton="bi-envelope"
                            variantBoton="btn-outline-primary"
                            tituloModal="Enviar correo al proveedor"
                            descripcionModal={`Se enviará un correo a ${proveedor.email}. Elige el tipo de mensaje.`}
                        />
                    )}
                    {(servicio?.estado === "Borrador" || servicio?.estado === "Desaprobado") && (
                        <button
                            type="button"
                            className={`btn btn-sm rounded-3 d-inline-flex align-items-center gap-2 fw-semibold ${llamadaIntentos > 0 ? "" : "btn-outline-secondary"}`}
                            style={(() => {
                                if (llamadaIntentos === 0) return { fontSize: "0.82rem" };
                                const cfg = RESULTADO_CONFIG[llamadaResultado];
                                if (cfg) return { background: cfg.color, color: "var(--blanco)", fontSize: "0.82rem" };
                                const c = llamadaIntentos >= 3 ? "var(--rojo-error)" : llamadaIntentos === 2 ? "var(--naranja-mapa)" : "var(--dorado-oscuro)";
                                return { background: c, color: "var(--blanco)", fontSize: "0.82rem" };
                            })()}
                            onClick={() => setMostrarModalLlamada(true)}
                        >
                            <i className={`bi ${RESULTADO_CONFIG[llamadaResultado]?.icon || (llamadaIntentos > 0 ? "bi-telephone-fill" : "bi-telephone")}`}></i>
                            {llamadaIntentos > 0
                                ? (RESULTADO_CONFIG[llamadaResultado]?.label || `${llamadaIntentos} intento${llamadaIntentos !== 1 ? "s" : ""}`)
                                : "Marcar llamada"}
                        </button>
                    )}
                    <ModalLlamarUsuario
                        show={mostrarModalLlamada}
                        onClose={() => setMostrarModalLlamada(false)}
                        guardando={marcandoLlamada}
                        intentosActuales={llamadaIntentos}
                        resultadoActual={llamadaResultado}
                        notaActual={llamadaNota}
                        onGuardar={async (intentos, resultado, nota) => {
                            try {
                                setMarcandoLlamada(true);
                                const res = await axios.post("/marcar-llamada-admin", { params: { idServicio: servicio.idServicio, intentos, resultado, nota } });
                                if (res.data.exito) {
                                    setLlamadaIntentos(res.data.intentos);
                                    setLlamadaResultado(res.data.resultado);
                                    setLlamadaNota(nota);
                                    setMostrarModalLlamada(false);
                                }
                            } catch { /* silencioso */ } finally { setMarcandoLlamada(false); }
                        }}
                    />
                    {(() => {
                        const estado   = servicio?.estado;
                        const tieneTel = proveedor?.telefono && proveedor.telefono !== "NA";

                        if (!tieneTel) return null;

                        if (estado === "Aprobado" || estado === "Borrador" || estado === "Desaprobado") {
                            return (
                                <button
                                    type="button"
                                    className="btn btn-sm rounded-3 d-inline-flex align-items-center gap-2 fw-semibold"
                                    style={{ background: "var(--verde-whatsapp)", color: "var(--blanco)", fontSize: "0.82rem" }}
                                    onClick={() => setMostrarModalWhatsapp(true)}
                                >
                                    <i className="bi bi-whatsapp"></i>WhatsApp
                                </button>
                            );
                        }

                        const nombreP  = [proveedor.nombre, proveedor.apellido].filter(v => v && v !== "NA").join(" ") || proveedor.username;
                        const tel      = proveedor.telefono.replace(/\D/g, "");
                        const telInt   = tel.startsWith("57") ? tel : `57${tel}`;
                        const textoMsg = estado === "Desaprobado"
                            ? `Hola ${nombreP}\n\nSomos el equipo de Zervicy y te escribimos porque tu servicio "${servicio.nombre || ""}" fue desaprobado.${servicio.mensajeRevision ? `\n\nMotivo: ${servicio.mensajeRevision}` : ""}\n\nQueremos ayudarte a corregirlo para que puedas publicarlo cuanto antes. Escribenos o llamanos y con gusto te explicamos los pasos a seguir.\n\nEstamos para ayudarte!`
                            : `Hola ${nombreP}\n\nSomos el equipo de Zervicy. Nos comunicamos contigo sobre tu servicio "${servicio.nombre || ""}". Tienes un momento para hablar?`;
                        return (
                            <button
                                type="button"
                                className="btn btn-sm rounded-3 d-inline-flex align-items-center gap-2 fw-semibold"
                                style={{ background: "var(--verde-whatsapp)", color: "var(--blanco)", fontSize: "0.82rem" }}
                                onClick={() => window.open(`https://wa.me/${telInt}?text=${encodeURIComponent(textoMsg)}`, "_blank", "noopener,noreferrer")}
                            >
                                <i className="bi bi-whatsapp"></i>WhatsApp
                            </button>
                        );
                    })()}
                    {(servicio?.estado === "Borrador" || servicio?.estado === "Desaprobado") && (
                        <button
                            type="button"
                            className="btn btn-outline-danger btn-sm rounded-3 d-inline-flex align-items-center gap-1"
                            onClick={eliminarServicio}
                            disabled={eliminando}
                        >
                            {eliminando
                                ? <><span className="spinner-border spinner-border-sm" style={{ width: 12, height: 12 }} />Eliminando...</>
                                : <><i className="bi bi-trash"></i>Eliminar servicio</>
                            }
                        </button>
                    )}
                    <button className="btn btn-outline-secondary btn-sm rounded-3" onClick={() => navigate(-1)}>
                        <i className="bi bi-arrow-left me-1"></i>Volver
                    </button>
                </div>
            </div>

            <div className="row g-4">
                {/* ── Columna izquierda ── */}
                <div className="col-12 col-lg-5">

                    {/* Proveedor */}
                    {proveedor && (
                        <div className="card border-0 shadow-sm rounded-4 mb-4">
                            <div className="card-body py-3 px-4">
                                <p className="text-muted small mb-2 fw-semibold text-uppercase" style={{ letterSpacing: "0.05em" }}>Vendedor</p>
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={proveedor.avatar || "/imagenes/marca/avatar.png"}
                                        alt={proveedor.username}
                                        className="rounded-circle flex-shrink-0"
                                        style={{ width: 48, height: 48, objectFit: "cover" }}
                                    />
                                    <div>
                                        <p className="mb-0 fw-semibold">{[proveedor.nombre, proveedor.apellido].filter(Boolean).join(" ") || "—"}</p>
                                        <p className="mb-0 text-muted small">@{proveedor.username} · {proveedor.email}</p>
                                    </div>
                                </div>
                                {val(proveedor.telefono) && (
                                    <p className="mb-1 mt-2 small text-muted">
                                        <i className="bi bi-telephone me-1"></i>
                                        {proveedor.telefono.replace(/\D/g, "").replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4")}
                                    </p>
                                )}
                                <div className="d-flex gap-1 flex-wrap mt-2">
                                    {[
                                        { ok: proveedor.perfilPersonalCompleto,                       label: "Perfil personal", icon: "bi-person-check-fill" },
                                        { ok: proveedor.infoBancariaCompleta,                         label: "Info bancaria",   icon: "bi-bank2" },
                                        { ok: proveedor.verificacionIdentidad?.estado === "aprobado", label: "Identidad",       icon: "bi-patch-check-fill" },
                                    ].map(({ ok, label, icon }) => (
                                        <span
                                            key={label}
                                            className={`badge rounded-pill border px-2 py-1 ${ok ? "bg-success-subtle text-success-emphasis border-success-subtle" : "bg-light text-muted"}`}
                                            style={{ fontSize: "0.68rem" }}
                                            title={`${label}: ${ok ? "Completado" : "Pendiente"}`}
                                        >
                                            <i className={`bi ${ok ? icon : "bi-circle"} me-1`}></i>{label}
                                        </span>
                                    ))}
                                </div>
                                <button
                                    className="btn btn-outline-primary btn-sm rounded-3 mt-3 w-100"
                                    onClick={() => navigate("/admin/usuario", { state: { params: { username: proveedor.username } } })}
                                >
                                    <i className="bi bi-person-badge me-1"></i>Ver vendedor
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Imágenes */}
                    {imgs.length > 0 && (
                        <div className="card border-0 shadow-sm rounded-4 mb-4">
                            <div className="card-body p-3">
                                <div style={{ position: 'relative' }}>
                                    <img
                                        src={imgs[imgActiva]}
                                        alt="Imagen servicio"
                                        className="w-100 rounded-3 mb-2"
                                        style={{ height: 220, objectFit: "cover", cursor: "zoom-in" }}
                                        onClick={() => setImagenExpandida(imgs[imgActiva])}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setImagenExpandida(imgs[imgActiva])}
                                        title="Ver imagen completa"
                                        style={{ position: 'absolute', top: 8, right: 8, width: 32, height: 32, borderRadius: '50%', border: 'none', backgroundColor: 'rgba(var(--negro-rgb), 0.55)', color: 'var(--blanco)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    >
                                        <i className="bi bi-arrows-fullscreen"></i>
                                    </button>
                                </div>
                                {imgs.length > 1 && (
                                    <div className="d-flex gap-2 flex-wrap">
                                        {imgs.map((img, i) => (
                                            <img
                                                key={i}
                                                src={img}
                                                alt={`img-${i}`}
                                                className={`rounded-2 ${i === imgActiva ? "border border-primary border-2" : ""}`}
                                                style={{ width: 52, height: 52, objectFit: "cover", cursor: "pointer", opacity: i === imgActiva ? 1 : 0.6 }}
                                                onClick={() => setImgActiva(i)}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Info general */}
                    <div className="card border-0 shadow-sm rounded-4 mb-4">
                        <div className="card-body py-3 px-4">
                            <h6 className="fw-semibold mb-3">Información general</h6>
                            <div className="row g-3">
                                {[
                                    { label: "Categoría",     val: val(servicio.categoria) },
                                    { label: "Subcategoría",  val: val(servicio.subcategoria) },
                                    { label: "Tipo",          val: val(servicio.tipoServicio) },
                                    { label: "Desplazamiento",val: val(servicio.tipoDesplazamiento) },
                                    { label: "Ciudad",        val: val(servicio.ciudad) },
                                    { label: "País",          val: val(servicio.pais) },
                                    { label: "Idioma",        val: val(servicio.idioma) },
                                    { label: "Urgente",       val: servicio.urgente ? "Sí" : "No" },
                                    { label: "Creado",        val: fmtFecha(servicio.fechaCreacion || servicio.createdAt) },
                                ].filter(r => r.val).map(({ label, val: v }) => (
                                    <div key={label} className="col-6">
                                        <p className="text-muted small mb-0">{label}</p>
                                        <p className="mb-0 fw-semibold small">{v}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Subzonas */}
                    {servicio.subzonas?.length > 0 && (
                        <div className="card border-0 shadow-sm rounded-4 mb-4">
                            <div className="card-body py-3 px-4">
                                <h6 className="fw-semibold mb-2">Zonas de cobertura</h6>
                                <div className="d-flex flex-wrap gap-2">
                                    {servicio.subzonas.map((z, i) => (
                                        <span key={i} className="badge rounded-pill bg-light text-dark border" style={{ fontSize: "0.75rem" }}>{z}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Mensaje revisión */}
                    {servicio.mensajeRevision && (
                        <div className="card border-0 shadow-sm rounded-4 mb-4" style={{ borderLeft: "3px solid var(--rojo-error) !important" }}>
                            <div className="card-body py-3 px-4">
                                <h6 className="fw-semibold text-danger mb-1"><i className="bi bi-exclamation-circle me-1"></i>Mensaje de revisión</h6>
                                <p className="mb-0 small">{servicio.mensajeRevision}</p>
                            </div>
                        </div>
                    )}
                </div>

                {/* ── Columna derecha ── */}
                <div className="col-12 col-lg-7">

                    {/* Descripción */}
                    {val(servicio.descripcion) && (
                        <div className="card border-0 shadow-sm rounded-4 mb-4">
                            <div className="card-body py-3 px-4">
                                <h6 className="fw-semibold mb-2">Descripción</h6>
                                <p className="mb-0 small" style={{ whiteSpace: "pre-line" }}>{servicio.descripcion}</p>
                            </div>
                        </div>
                    )}

                    {/* Paquetes */}
                    {servicio.paquetes?.length > 0 && (
                        <div className="card border-0 shadow-sm rounded-4 mb-4">
                            <div className="card-body py-3 px-4">
                                <h6 className="fw-semibold mb-3">Paquetes</h6>
                                <div className="d-flex flex-column gap-3">
                                    {servicio.paquetes.map((p, i) => {
                                        const col = TIPO_PAQUETE_COLOR[p.tipo] || {};
                                        return (
                                            <div key={i} className="rounded-3 p-3" style={{ background: col.bg || "var(--color-track-bg)" }}>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="fw-semibold" style={{ color: col.color }}>{p.tipo}</span>
                                                    <span className="fw-bold">{fmtPrecio(p.precio)}</span>
                                                </div>
                                                {p.descripcion && p.descripcion !== "NA" && (
                                                    <p className="small mb-2 text-muted">{p.descripcion}</p>
                                                )}
                                                <div className="d-flex flex-wrap gap-3 small text-muted">
                                                    <span>
                                                        <i className="bi bi-clock me-1"></i>
                                                        {p.unidadEntrega === "Horas"
                                                            ? `${p.duracionCitaMin || "?"} min`
                                                            : `${p.diasEntrega || 1} día${p.diasEntrega !== 1 ? "s" : ""}`}
                                                    </span>
                                                    {p.unidadEntrega !== "Dias" && p.modoAgenda && p.modoAgenda !== "NA" && <span><i className="bi bi-calendar3 me-1"></i>{p.modoAgenda}</span>}
                                                    {p.citasDia > 0 && <span><i className="bi bi-people me-1"></i>{p.citasDia} citas/día</span>}
                                                </div>
                                                {Array.isArray(p.diasSemana) && p.diasSemana.length > 0 && (() => {
                                                    const ETIQ = { 1:"Lun", 2:"Mar", 3:"Mié", 4:"Jue", 5:"Vie", 6:"Sáb", 7:"Dom" };
                                                    return (
                                                        <div className="d-flex flex-wrap gap-1 mt-2">
                                                            {[1,2,3,4,5,6,7].map(n => {
                                                                const activo = p.diasSemana.includes(n);
                                                                return (
                                                                    <span key={n} className="badge rounded-pill" style={{
                                                                        fontSize: "0.7rem",
                                                                        background: activo ? col.bg || "var(--color-track-bg)" : "transparent",
                                                                        color: activo ? col.color || "var(--gris-texto-333)" : "var(--gris-bbb)",
                                                                        border: `1px solid ${activo ? col.color || "var(--color-border)" : "var(--color-border)"}`,
                                                                        fontWeight: activo ? 600 : 400,
                                                                    }}>{ETIQ[n]}</span>
                                                                );
                                                            })}
                                                        </div>
                                                    );
                                                })()}
                                                {p.modoAgenda === "exacta" && Array.isArray(p.horariosDia) && p.horariosDia.length > 0 && (
                                                    <div className="d-flex flex-wrap gap-1 mt-2">
                                                        {p.horariosDia.filter(h => String(h || "").trim()).map((h, i) => (
                                                            <span key={i} className="badge rounded-pill" style={{
                                                                fontSize: "0.7rem",
                                                                background: col.bg || "var(--color-track-bg)",
                                                                color: col.color || "var(--gris-texto-333)",
                                                                border: `1px solid ${col.color || "var(--color-border)"}`,
                                                                fontWeight: 600,
                                                            }}><i className="bi bi-clock me-1" style={{ fontSize: "0.6rem" }}></i>{h}</span>
                                                        ))}
                                                    </div>
                                                )}
                                                {p.modoAgenda === "exacta" && Array.isArray(p.horariosDia) && p.horariosDia.length === 0 && (
                                                    <div className="mt-2">
                                                        <span className="badge rounded-pill text-danger" style={{ fontSize: "0.7rem", background: "rgba(var(--rojo-error-rgb), 0.1)", border: "1px solid var(--rojo-error)" }}>
                                                            <i className="bi bi-exclamation-circle me-1"></i>Sin horarios configurados
                                                        </span>
                                                    </div>
                                                )}
                                                {p.detalles?.length > 0 && (
                                                    <ul className="mt-2 mb-0 ps-3 small">
                                                        {p.detalles.map((d, j) => <li key={j}>{d}</li>)}
                                                    </ul>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* FAQ */}
                    {servicio.faq?.length > 0 && (
                        <div className="card border-0 shadow-sm rounded-4 mb-4">
                            <div className="card-body py-3 px-4">
                                <h6 className="fw-semibold mb-3">Preguntas frecuentes</h6>
                                <div className="d-flex flex-column gap-3">
                                    {servicio.faq.filter(f => val(f.pregunta)).map((f, i) => (
                                        <div key={i}>
                                            <p className="mb-1 fw-semibold small">{f.pregunta}</p>
                                            <p className="mb-0 small text-muted">{val(f.respuesta) || "—"}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Valoraciones */}
                    <div className="card border-0 shadow-sm rounded-4">
                        <div className="card-body py-3 px-4">
                            <div className="d-flex align-items-center gap-3 mb-3">
                                <h6 className="fw-semibold mb-0">Valoraciones</h6>
                                {promedio !== null && (
                                    <span className="ms-auto">
                                        <i className="bi bi-star-fill text-warning me-1"></i>
                                        <strong>{promedio}</strong>
                                        <span className="text-muted small ms-1">({valoraciones.length})</span>
                                    </span>
                                )}
                            </div>
                            {valoraciones.length === 0 ? (
                                <p className="text-muted small mb-0">Sin valoraciones aún.</p>
                            ) : (
                                <div className="d-flex flex-column gap-3">
                                    {valoraciones.slice(0, 6).map((v, i) => (
                                        <div key={i} className="border-bottom pb-3">
                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                <span className="fw-semibold small">{v.nombreUsuario || "Usuario"}</span>
                                                <span className="text-warning small">{"★".repeat(Math.min(5, v.calificacion || 0))}</span>
                                                <span className="text-muted small ms-auto">{fmtFecha(v.fecha || v.createdAt)}</span>
                                            </div>
                                            {v.comentario && <p className="mb-0 small text-muted">{v.comentario}</p>}
                                        </div>
                                    ))}
                                    {valoraciones.length > 6 && (
                                        <p className="text-muted small mb-0 text-center">… y {valoraciones.length - 6} valoración{valoraciones.length - 6 !== 1 ? "es" : ""} más</p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Panel de edición: Borrador + SuperAdmin o Soporte ── */}
            {servicio.estado === "Borrador" && puedeEditar && (
                <div className="mt-5">
                    <div className="d-flex align-items-center gap-3 mb-4 pb-2 border-bottom">
                        <div>
                            <h4 className="mb-0 fw-bold text-dark">Edición de servicio</h4>
                            <p className="text-muted small mb-0">Estás ayudando a <strong>@{proveedor?.username}</strong> a completar su servicio.</p>
                        </div>
                        <div className="ms-auto">
                            <ModalUsarIA
                                idServicio={servicio.idServicio}
                                usoIA={servicio.usoIA}
                                onSuccess={resultado => {
                                    if (resultado.titulo)      setFormEdit(f => ({ ...f, titulo:      resultado.titulo }));
                                    if (resultado.descripcion) setFormEdit(f => ({ ...f, descripcion: resultado.descripcion }));
                                    if (resultado.paquete) {
                                        setPaquetesEdit(prev => prev.map(p =>
                                            p.tipo === "Básico"
                                                ? { ...p,
                                                    descripcion: resultado.paquete.descripcion || p.descripcion,
                                                    detalles:    Array.isArray(resultado.paquete.detalles)
                                                        ? resultado.paquete.detalles.join("\n")
                                                        : p.detalles,
                                                  }
                                                : p
                                        ));
                                    }
                                    if (resultado.faq) {
                                        setFaqEdit([{ pregunta: resultado.faq.pregunta || "", respuesta: resultado.faq.respuesta || "" }]);
                                    }
                                    setServicio(s => ({ ...s, usoIA: (s.usoIA || 0) + 1 }));
                                }}
                            />
                        </div>
                    </div>

                    {/* ── Paso 1: tipo de servicio ── */}
                    <p className="text-muted small fw-bold text-uppercase mb-2" style={{ letterSpacing: "0.08em" }}>Paso 1</p>
                    <div className="card border rounded-3 p-3 mb-4">
                        <h6 className="fw-bold mb-3">Tipo de servicio</h6>
                        <div className="row g-2">
                            <div className="col-6">
                                <button
                                    type="button"
                                    className={`btn w-100 py-2 fw-semibold ${tipoServicioEdit === "Presencial" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => {
                                        setTipoServicioEdit("Presencial");
                                        if (tipoDesplazamientoEdit === "Nodefinido") setTipoDesplazamientoEdit("Domicilio");
                                    }}
                                >
                                    <i className="bi bi-geo-alt me-2"></i>Presencial
                                </button>
                            </div>
                            <div className="col-6">
                                <button
                                    type="button"
                                    className={`btn w-100 py-2 fw-semibold ${tipoServicioEdit === "Digital" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => {
                                        setTipoServicioEdit("Digital");
                                        setTipoDesplazamientoEdit("Nodefinido");
                                        setServicioUrgenteEdit(false);
                                    }}
                                >
                                    <i className="bi bi-laptop me-2"></i>Digital
                                </button>
                            </div>
                        </div>

                        {tipoServicioEdit === "Presencial" && (
                            <>
                                <h6 className="fw-bold mt-3 mb-2">¿Cómo se presta?</h6>
                                <div className="row g-2">
                                    <div className="col-6">
                                        <button
                                            type="button"
                                            className={`btn w-100 py-2 fw-semibold ${tipoDesplazamientoEdit === "Domicilio" ? "btn-primary" : "btn-outline-primary"}`}
                                            onClick={() => setTipoDesplazamientoEdit("Domicilio")}
                                        >
                                            <i className="bi bi-house-door me-2"></i>Domicilio
                                        </button>
                                    </div>
                                    <div className="col-6">
                                        <button
                                            type="button"
                                            className={`btn w-100 py-2 fw-semibold ${tipoDesplazamientoEdit === "EnLocal" ? "btn-primary" : "btn-outline-primary"}`}
                                            onClick={() => setTipoDesplazamientoEdit("EnLocal")}
                                        >
                                            <i className="bi bi-shop me-2"></i>En local
                                        </button>
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <button
                                        type="button"
                                        className={`btn py-2 fw-semibold ${servicioUrgenteEdit ? "btn-primary" : "btn-outline-secondary"}`}
                                        onClick={() => setServicioUrgenteEdit(v => !v)}
                                    >
                                        <i className={`bi ${servicioUrgenteEdit ? "bi-lightning-fill" : "bi-lightning"} me-2`}></i>
                                        {servicioUrgenteEdit ? "Urgente activado" : "Marcar como urgente"}
                                    </button>
                                </div>
                                {servicioUrgenteEdit && (
                                    <div className="alert alert-warning mt-2 mb-0 small">
                                        Permite reservas desde las próximas 2 h hasta 24 h con recargo de hasta 35%.
                                    </div>
                                )}
                            </>
                        )}
                    </div>

                    {/* ── Paso 2: descripción, categoría y ubicación ── */}
                    {(() => {
                        const subcatsDisponibles = Array.isArray(cateConfig.find(c => c.categoria === categoriaEdit)?.subcategorias)
                            ? cateConfig.find(c => c.categoria === categoriaEdit).subcategorias : [];
                        const subZonasDisponibles = Array.isArray(subZonasPorCiudadEdit?.[ciudadEdit])
                            ? subZonasPorCiudadEdit[ciudadEdit] : [];
                        const mostrarSubzonas = Boolean(ciudadEdit) && subZonasDisponibles.length > 0;
                        const labelSubZona = String(subZonaTipoEdit || "Subzona").replace(/_/g, " ");
                        const esDomicilio = tipoDesplazamientoEdit === "Domicilio";
                        const esEnLocal   = tipoDesplazamientoEdit === "EnLocal";

                        function toggleSubzona(valor) {
                            if (valor === "__toda__") {
                                const nuevaCobertura = !coberturaEdit;
                                setCoberturaEdit(nuevaCobertura);
                                setSubzonasEdit(nuevaCobertura ? [...subZonasDisponibles] : []);
                                return;
                            }
                            setSubzonasEdit(prev => {
                                const existe = prev.includes(valor);
                                return existe ? prev.filter(x => x !== valor) : [...prev, valor];
                            });
                            setCoberturaEdit(false);
                        }

                        return (
                            <>
                                <p className="text-muted small fw-bold text-uppercase mb-2 mt-2" style={{ letterSpacing: "0.08em" }}>Paso 2</p>
                                <div className="card border rounded-3 p-3 mb-4">
                                    <div className="row g-3">
                                        {/* Título */}
                                        <div className="col-12">
                                            <label className="form-label fw-semibold small">Título del servicio</label>
                                            <input
                                                type="text"
                                                className="form-control rounded-3"
                                                value={formEdit.titulo}
                                                onChange={e => setFormEdit(f => ({ ...f, titulo: e.target.value }))}
                                                placeholder="Ej: Limpieza de apartamento para Airbnb"
                                                maxLength={100}
                                            />
                                        </div>

                                        {/* Descripción */}
                                        <div className="col-12">
                                            <label className="form-label fw-semibold small">Descripción</label>
                                            <textarea
                                                className="form-control rounded-3"
                                                rows={5}
                                                value={formEdit.descripcion}
                                                onChange={e => setFormEdit(f => ({ ...f, descripcion: e.target.value }))}
                                                placeholder="Describe qué ofrece el servicio, para quién es, qué resultados obtendrá el cliente..."
                                            />
                                        </div>

                                        {/* Categoría */}
                                        <div className="col-12 col-md-6">
                                            <label className="form-label fw-semibold small">Categoría</label>
                                            <select
                                                className="form-select rounded-3"
                                                value={categoriaEdit}
                                                onChange={e => { setCategoriaEdit(e.target.value); setSubCategoriaEdit(""); }}
                                            >
                                                <option value="">Selecciona una categoría</option>
                                                {cateConfig.map((c, i) => (
                                                    <option key={c.categoria || i} value={c.categoria}>{c.categoria}</option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Subcategoría */}
                                        {categoriaEdit && (
                                            <div className="col-12 col-md-6">
                                                <label className="form-label fw-semibold small">Subcategoría</label>
                                                <select
                                                    className="form-select rounded-3"
                                                    value={subCategoriaEdit}
                                                    onChange={e => setSubCategoriaEdit(e.target.value)}
                                                    disabled={subcatsDisponibles.length === 0}
                                                >
                                                    <option value="">Selecciona una subcategoría</option>
                                                    {subcatsDisponibles.map((s, i) => (
                                                        <option key={s + i} value={s}>{s}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}

                                        {/* Ubicación — solo si es Presencial */}
                                        {tipoServicioEdit === "Presencial" && (
                                            <>
                                                <div className="col-12"><hr className="my-1" /><p className="fw-semibold small mb-0">Ubicación</p></div>

                                                {/* País (readonly) */}
                                                <div className="col-12 col-md-4">
                                                    <label className="form-label fw-semibold small">País</label>
                                                    <input type="text" className="form-control rounded-3" value={servicio.pais || "Colombia"} readOnly />
                                                </div>

                                                {/* Zona / Departamento */}
                                                <div className="col-12 col-md-4">
                                                    <label className="form-label fw-semibold small">Zona / Departamento</label>
                                                    <select
                                                        className="form-select rounded-3"
                                                        value={zonaEdit}
                                                        onChange={e => {
                                                            const z = e.target.value;
                                                            setZonaEdit(z);
                                                            const zonaEnc = zonas.find(x => x.departamento === z);
                                                            setCiudadesEdit(Array.isArray(zonaEnc?.ciudades) ? zonaEnc.ciudades : []);
                                                            setSubZonaTipoEdit(zonaEnc?.subzonasTipo || "");
                                                            setSubZonasPorCiudadEdit(zonaEnc?.subzonasPorCiudad || {});
                                                            setCiudadEdit("");
                                                            setSubzonasEdit([]);
                                                            setCoberturaEdit(false);
                                                        }}
                                                    >
                                                        <option value="">Selecciona una zona</option>
                                                        {zonas.map((z, i) => (
                                                            <option key={z.departamento || i} value={z.departamento}>{z.departamento}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                {/* Ciudad */}
                                                <div className="col-12 col-md-4">
                                                    <label className="form-label fw-semibold small">Ciudad</label>
                                                    <select
                                                        className="form-select rounded-3"
                                                        value={ciudadEdit}
                                                        onChange={e => {
                                                            setCiudadEdit(e.target.value);
                                                            setSubzonasEdit([]);
                                                            setCoberturaEdit(false);
                                                        }}
                                                        disabled={!zonaEdit}
                                                    >
                                                        <option value="">Selecciona una ciudad</option>
                                                        {ciudadesEdit.map((c, i) => (
                                                            <option key={c + i} value={c}>{c}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                {/* Subzonas — Domicilio */}
                                                {mostrarSubzonas && esDomicilio && (
                                                    <div className="col-12">
                                                        <label className="form-label fw-semibold small">{labelSubZona}</label>
                                                        <div className="border rounded-3 p-3" style={{ maxHeight: 220, overflowY: "auto" }}>
                                                            <div className="form-check mb-2">
                                                                <input
                                                                    className="form-check-input" type="checkbox"
                                                                    id="cobertura-toda"
                                                                    checked={coberturaEdit}
                                                                    onChange={() => toggleSubzona("__toda__")}
                                                                />
                                                                <label className="form-check-label" htmlFor="cobertura-toda">
                                                                    Todo {ciudadEdit}
                                                                </label>
                                                            </div>
                                                            <div className="border-top pt-2">
                                                                {subZonasDisponibles.map((sz, i) => (
                                                                    <div className="form-check mb-1" key={sz + i}>
                                                                        <input
                                                                            className="form-check-input" type="checkbox"
                                                                            id={`sz-${i}`}
                                                                            checked={subzonasEdit.includes(sz)}
                                                                            disabled={coberturaEdit}
                                                                            onChange={() => toggleSubzona(sz)}
                                                                        />
                                                                        <label className="form-check-label small" htmlFor={`sz-${i}`}>{sz}</label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Subzonas — EnLocal (dropdown) */}
                                                {mostrarSubzonas && esEnLocal && (
                                                    <div className="col-12 col-md-6">
                                                        <label className="form-label fw-semibold small">Localidad</label>
                                                        <select
                                                            className="form-select rounded-3"
                                                            value={subzonasEdit[0] || ""}
                                                            onChange={e => setSubzonasEdit(e.target.value ? [e.target.value] : [])}
                                                        >
                                                            <option value="">Selecciona una localidad</option>
                                                            {subZonasDisponibles.map((sz, i) => (
                                                                <option key={sz + i} value={sz}>{sz}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}

                                                {/* Dirección y referencia — EnLocal */}
                                                {esEnLocal && (
                                                    <>
                                                        <div className="col-12 col-md-6">
                                                            <label className="form-label fw-semibold small">Dirección</label>
                                                            <input
                                                                type="text"
                                                                className="form-control rounded-3"
                                                                value={direccionEdit}
                                                                onChange={e => setDireccionEdit(e.target.value)}
                                                                placeholder="Calle 123 #45-67"
                                                            />
                                                        </div>
                                                        <div className="col-12 col-md-6">
                                                            <label className="form-label fw-semibold small">Referencia</label>
                                                            <input
                                                                type="text"
                                                                className="form-control rounded-3"
                                                                value={referenciaEdit}
                                                                onChange={e => setReferenciaEdit(e.target.value)}
                                                                placeholder="Apto 301, casa azul, frente al parque"
                                                            />
                                                        </div>
                                                        <div className="col-12">
                                                            <label className="form-label fw-semibold small">Ubicación en el mapa</label>
                                                            <div className="alert alert-info small py-2 mb-2">
                                                                Haz clic en el mapa para marcar la ubicación exacta del local.
                                                            </div>
                                                            <MapaUbicacionServicio
                                                                latitud={latitudEdit}
                                                                longitud={longitudEdit}
                                                                onChange={(lat, lng) => { setLatitudEdit(lat); setLongitudEdit(lng); }}
                                                                ubicacionUsuario={null}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </>
                        );
                    })()}

                    {/* ── Paso 3: fotos ── */}
                    <p className="text-muted small fw-bold text-uppercase mb-2 mt-2" style={{ letterSpacing: "0.08em" }}>Paso 3</p>
                    <div className="card border rounded-3 p-3 mb-4">
                        <h6 className="fw-bold mb-1">Fotos del servicio</h6>
                        <p className="small text-muted mb-3">Las fotos se guardan automáticamente al subir. Recomendado: cuadradas (1:1), menos de 2 MB.</p>
                        {(!categoriaEdit || !subCategoriaEdit) && (
                            <div className="alert alert-warning small py-2 mb-3 d-flex align-items-center gap-2">
                                <i className="bi bi-lock-fill flex-shrink-0"></i>
                                <span>Selecciona una <strong>categoría y subcategoría</strong> (Paso 2) antes de subir fotos.</span>
                            </div>
                        )}
                        <div className="row g-3">
                            {[0, 1, 2, 3, 4, 5, 6, 7].map(i => {
                                const locked = !categoriaEdit || !subCategoriaEdit;
                                return (
                                    <div key={i} className="col-6 col-md-3">
                                        <label style={{ cursor: locked ? "not-allowed" : "pointer", display: "block" }}>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                style={{ display: "none" }}
                                                disabled={locked}
                                                onChange={e => {
                                                    if (e.target.files[0]) subirImagenAdmin(e.target.files[0], i);
                                                    e.target.value = "";
                                                }}
                                            />
                                            <div
                                                className="rounded-3 d-flex align-items-center justify-content-center text-center position-relative"
                                                style={{ height: 150, border: `2px dashed ${locked ? "var(--color-border)" : "var(--color-border)"}`, background: locked ? "var(--gris-modal-texto)" : "var(--gris-muy-claro)", overflow: "hidden", opacity: locked ? 0.6 : 1 }}
                                            >
                                                {locked ? (
                                                    <div className="text-muted small">
                                                        <i className="bi bi-lock d-block fs-3 mb-1"></i>
                                                        <span style={{ fontSize: "0.7rem" }}>Sin categoría</span>
                                                    </div>
                                                ) : imagenesAdminUI[i]?.subiendo ? (
                                                    <div className="text-muted small">
                                                        <span className="spinner-border spinner-border-sm me-2" />Subiendo...
                                                    </div>
                                                ) : imagenesAdminUI[i]?.preview ? (
                                                    <>
                                                        <img
                                                            src={imagenesAdminUI[i].preview}
                                                            alt={`foto-${i + 1}`}
                                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                        />
                                                        <div
                                                            className="position-absolute bottom-0 start-0 end-0 text-white text-center small py-1"
                                                            style={{ background: "rgba(var(--negro-rgb), 0.5)" }}
                                                        >
                                                            <i className="bi bi-pencil me-1"></i>Cambiar
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="text-muted small">
                                                        <i className="bi bi-image d-block fs-3 mb-1"></i>
                                                        Foto {i + 1}
                                                    </div>
                                                )}
                                            </div>
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* ── Paso 4: paquetes ── */}
                    {paquetesEdit.length > 0 && (() => {
                        const agendaBase   = paquetesEdit[0];
                        const porHoras     = (agendaBase.unidadEntrega || "Horas") === "Horas";
                        const esFlexible   = (agendaBase.modoAgenda || "exacta") === "flexible";
                        const paqActivo    = paquetesEdit.find(p => p.tipo === paqueteActivoEdit) || paquetesEdit[0];
                        const DIAS = [
                            { n: 1, t: "Lun" }, { n: 2, t: "Mar" }, { n: 3, t: "Mié" },
                            { n: 4, t: "Jue" }, { n: 5, t: "Vie" }, { n: 6, t: "Sáb" }, { n: 7, t: "Dom" },
                        ];
                        return (
                            <>
                                <p className="text-muted small fw-bold text-uppercase mb-2 mt-2" style={{ letterSpacing: "0.08em" }}>Paso 4</p>
                                <div className="card border rounded-3 p-3 mb-4">

                                    {/* ── Cantidad de paquetes ── */}
                                    <div className="row g-3 align-items-end mb-3">
                                        <div className="col-12 col-md-6">
                                            <label className="form-label fw-semibold small">Cantidad de paquetes</label>
                                            <select className="form-select rounded-3"
                                                value={cantidadPaquetesEdit}
                                                onChange={e => cambiarCantidadPaquetes(parseInt(e.target.value, 10))}
                                            >
                                                <option value={1}>1 — Solo Básico</option>
                                                <option value={2}>2 — Básico + Premium</option>
                                                <option value={3}>3 — Básico + Premium + Avanzado</option>
                                            </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="alert alert-info mb-0 small py-2">
                                                <strong>Tip:</strong> empieza con 1 paquete. Añade más cuando el usuario ya tenga pedidos.
                                            </div>
                                        </div>
                                    </div>

                                    {/* ── Agenda compartida ── */}
                                    <div className="border rounded-3 p-3 mb-3 bg-light">
                                        <p className="fw-bold small text-muted mb-3 text-uppercase" style={{ fontSize: 12, letterSpacing: "0.05em" }}>Configuración de agenda — aplica a todos los paquetes</p>

                                        <div className="row g-3">
                                            {/* Días de la semana */}
                                            <div className="col-12 col-lg-6">
                                                <label className="form-label fw-semibold small">Días disponibles</label>
                                                <div className="d-flex flex-wrap gap-2 mb-2">
                                                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => actualizarTodosLosPaquetesEdit("diasSemana", [1,2,3,4,5])}>Lun–Vie</button>
                                                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => actualizarTodosLosPaquetesEdit("diasSemana", [6,7])}>Fin de semana</button>
                                                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => actualizarTodosLosPaquetesEdit("diasSemana", [1,2,3,4,5,6,7])}>Todos</button>
                                                    <button type="button" className="btn btn-sm btn-secondary"       onClick={() => actualizarTodosLosPaquetesEdit("diasSemana", [])}>Limpiar</button>
                                                </div>
                                                <div className="d-flex flex-wrap gap-2">
                                                    {DIAS.map(d => {
                                                        const sel = Array.isArray(agendaBase.diasSemana) ? agendaBase.diasSemana : [];
                                                        const activo = sel.includes(d.n);
                                                        return (
                                                            <button key={d.n} type="button"
                                                                className={`btn btn-sm ${activo ? "btn-primary" : "btn-outline-primary"}`}
                                                                onClick={() => {
                                                                    const next = activo ? sel.filter(x => x !== d.n) : [...sel, d.n].sort((a,b) => a-b);
                                                                    actualizarTodosLosPaquetesEdit("diasSemana", next);
                                                                }}
                                                            >{d.t}</button>
                                                        );
                                                    })}
                                                </div>
                                            </div>

                                            {/* Duración */}
                                            <div className="col-12 col-lg-6">
                                                <label className="form-label fw-semibold small">Duración del servicio</label>
                                                <select className="form-select form-select-sm rounded-3"
                                                    value={agendaBase.unidadEntrega || "Horas"}
                                                    onChange={e => actualizarTodosLosPaquetesEdit("unidadEntrega", e.target.value)}
                                                >
                                                    <option value="Horas">Horas (por cita)</option>
                                                    <option value="Dias" disabled={!!servicioUrgenteEdit}>Días (por entrega){servicioUrgenteEdit ? " — no compatible con urgente" : ""}</option>
                                                </select>
                                                {!porHoras && (
                                                    <p className="text-muted mt-2 mb-0" style={{ fontSize: 12 }}>
                                                        Los días de entrega se configuran en cada paquete a continuación.
                                                    </p>
                                                )}
                                            </div>

                                            {/* Agenda por horas */}
                                            {porHoras && (
                                                <>
                                                    <div className="col-12 col-md-6">
                                                        <label className="form-label fw-semibold small">Tipo de agenda</label>
                                                        <div className="d-flex gap-2">
                                                            <button type="button"
                                                                className={`btn btn-sm ${!esFlexible ? "btn-primary" : "btn-outline-primary"}`}
                                                                onClick={() => actualizarTodosLosPaquetesEdit("modoAgenda", "exacta")}
                                                            >Horarios exactos</button>
                                                            {!servicioUrgenteEdit && (
                                                                <button type="button"
                                                                    className={`btn btn-sm ${esFlexible ? "btn-primary" : "btn-outline-primary"}`}
                                                                    onClick={() => actualizarTodosLosPaquetesEdit("modoAgenda", "flexible")}
                                                                >Flexible</button>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Franjas (flexible) */}
                                                    {esFlexible && (
                                                        <div className="col-12">
                                                            <label className="form-label fw-semibold small">Franjas horarias</label>
                                                            <div className="d-flex flex-wrap gap-2">
                                                                {[{ k: "manana", t: "Mañana (7–12)" }, { k: "tarde", t: "Tarde (12–18)" }, { k: "noche", t: "Noche (18–22)" }].map(f => {
                                                                    const sel = Array.isArray(agendaBase.franjasDia) ? agendaBase.franjasDia : [];
                                                                    const activo = sel.includes(f.k);
                                                                    return (
                                                                        <button key={f.k} type="button"
                                                                            className={`btn btn-sm ${activo ? "btn-primary" : "btn-outline-primary"}`}
                                                                            onClick={() => actualizarTodosLosPaquetesEdit("franjasDia", activo ? sel.filter(x => x !== f.k) : [...sel, f.k])}
                                                                        >{f.t}</button>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Horarios exactos: se configuran por paquete */}
                                                    {!esFlexible && (
                                                        <div className="col-12">
                                                            <p className="text-muted mb-0" style={{ fontSize: 12 }}>
                                                                La cantidad de servicios y los horarios exactos se configuran en cada paquete a continuación.
                                                            </p>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>

                                    {/* ── Tabs de paquetes ── */}
                                    <ul className="nav nav-tabs">
                                        {paquetesEdit.map(p => (
                                            <li key={p.tipo} className="nav-item">
                                                <button type="button"
                                                    className={`nav-link ${paqActivo.tipo === p.tipo ? "active" : ""}`}
                                                    onClick={() => setPaqueteActivoEdit(p.tipo)}
                                                >{p.tipo}</button>
                                            </li>
                                        ))}
                                    </ul>

                                    {/* Formulario del paquete activo */}
                                    <div className="border border-top-0 rounded-bottom p-3">
                                        <div className="row g-3">
                                            {/* Precio */}
                                            <div className="col-12 col-md-6">
                                                <label className="form-label fw-semibold small">Precio (COP)</label>
                                                <input type="number" className="form-control rounded-3"
                                                    value={paqActivo.precio}
                                                    onChange={e => actualizarPaqueteEdit(paqActivo.tipo, "precio", e.target.value)}
                                                    placeholder="Ej: 50000"
                                                />
                                            </div>
                                            {/* Duración por cita (solo Horas) */}
                                            {porHoras && (
                                                <div className="col-12 col-md-6">
                                                    <label className="form-label fw-semibold small">Duración por cita</label>
                                                    <select
                                                        className="form-select rounded-3"
                                                        value={paqActivo.duracionCitaMin}
                                                        onChange={e => actualizarPaqueteEdit(paqActivo.tipo, "duracionCitaMin", e.target.value)}
                                                    >
                                                        <option value="">Selecciona la duración</option>
                                                        {[
                                                            { min: 15,  label: "15 minutos"     },
                                                            { min: 20,  label: "20 minutos"     },
                                                            { min: 30,  label: "30 minutos"     },
                                                            { min: 45,  label: "45 minutos"     },
                                                            { min: 60,  label: "1 hora"         },
                                                            { min: 75,  label: "1 h 15 min"     },
                                                            { min: 90,  label: "1 hora 30 min"  },
                                                            { min: 105, label: "1 h 45 min"     },
                                                            { min: 120, label: "2 horas"        },
                                                            { min: 150, label: "2 horas 30 min" },
                                                            { min: 180, label: "3 horas"        },
                                                            { min: 210, label: "3 horas 30 min" },
                                                            { min: 240, label: "4 horas"        },
                                                            { min: 270, label: "4 horas 30 min" },
                                                            { min: 300, label: "5 horas"        },
                                                            { min: 360, label: "6 horas"        },
                                                            { min: 420, label: "7 horas"        },
                                                            { min: 480, label: "8 horas"        },
                                                            { min: 540, label: "9 horas"        },
                                                            { min: 600, label: "10 horas"       },
                                                        ].map(({ min, label }) => (
                                                            <option key={min} value={min}>{label}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            )}
                                            {/* Días de entrega — por paquete (solo Días) */}
                                            {!porHoras && (
                                                <div className="col-12 col-md-6">
                                                    <label className="form-label fw-semibold small">¿Cuántos días tarda este paquete?</label>
                                                    <select className="form-select rounded-3"
                                                        value={String(paqActivo.diasEntrega || "")}
                                                        onChange={e => actualizarPaqueteEdit(paqActivo.tipo, "diasEntrega", e.target.value)}
                                                    >
                                                        <option value="">Selecciona</option>
                                                        {Array.from({ length: 30 }).map((_, i) => {
                                                            const n = i + 1;
                                                            return <option key={n} value={n}>{n} día{n > 1 ? "s" : ""}</option>;
                                                        })}
                                                    </select>
                                                    <small className="text-muted">Puede variar por paquete.</small>
                                                </div>
                                            )}
                                            {/* Servicios por día — por paquete (solo Horas) */}
                                            {porHoras && (
                                                <div className="col-12 col-md-6">
                                                    <label className="form-label fw-semibold small">¿Cuántos de este paquete puedes hacer en un día?</label>
                                                    <select className="form-select rounded-3"
                                                        value={paqActivo.citasDia || ""}
                                                        onChange={e => {
                                                            const n = Number(e.target.value);
                                                            const lim = Number.isFinite(n) ? Math.max(1, Math.min(12, n)) : 0;
                                                            const prevHor = Array.isArray(paqActivo.horariosDia) ? paqActivo.horariosDia : [];
                                                            actualizarPaqueteEdit(paqActivo.tipo, "citasDia", lim ? String(lim) : "");
                                                            actualizarPaqueteEdit(paqActivo.tipo, "horariosDia", lim > 0 ? Array.from({ length: lim }).map((_, i) => prevHor[i] || "") : []);
                                                        }}
                                                    >
                                                        <option value="">Selecciona</option>
                                                        {Array.from({ length: 12 }).map((_, i) => <option key={i+1} value={i+1}>{i+1}</option>)}
                                                    </select>
                                                    <small className="text-muted">Puede variar según la duración de este paquete.</small>
                                                </div>
                                            )}
                                            {/* Horarios exactos — por paquete (solo Horas + exacta) */}
                                            {porHoras && !esFlexible && Number(paqActivo.citasDia) > 0 && (
                                                <div className="col-12">
                                                    <label className="form-label fw-semibold small">Horarios disponibles para este paquete</label>
                                                    <div className="row g-2">
                                                        {(Array.isArray(paqActivo.horariosDia) ? paqActivo.horariosDia : []).map((h, idx) => (
                                                            <div className="col-12 col-sm-6 col-lg-4" key={`hor-${paqActivo.tipo}-${idx}`}>
                                                                <div className="input-group input-group-sm">
                                                                    <span className="input-group-text">#{idx + 1}</span>
                                                                    <input type="time" className="form-control" value={h || ""}
                                                                        onChange={e => {
                                                                            const arr = [...(Array.isArray(paqActivo.horariosDia) ? paqActivo.horariosDia : [])];
                                                                            arr[idx] = e.target.value;
                                                                            actualizarPaqueteEdit(paqActivo.tipo, "horariosDia", arr);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                            {/* Descripción */}
                                            <div className="col-12">
                                                <label className="form-label fw-semibold small">Descripción corta</label>
                                                <input type="text" className="form-control rounded-3" maxLength={200}
                                                    value={paqActivo.descripcion}
                                                    onChange={e => actualizarPaqueteEdit(paqActivo.tipo, "descripcion", e.target.value)}
                                                    placeholder="Ej: Incluye X, Y, Z"
                                                />
                                            </div>
                                            {/* Detalles */}
                                            <div className="col-12">
                                                <label className="form-label fw-semibold small">Lo que incluye <span className="fw-normal text-muted">(una por línea)</span></label>
                                                <textarea className="form-control rounded-3" rows={4} maxLength={800}
                                                    value={paqActivo.detalles}
                                                    onChange={e => actualizarPaqueteEdit(paqActivo.tipo, "detalles", e.target.value)}
                                                    placeholder={"Revisiones ilimitadas\nEntrega en 3 días\nArchivos en SVG y PNG"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        );
                    })()}

                    {/* ── Paso 5: FAQ ── */}
                    <p className="text-muted small fw-bold text-uppercase mb-2 mt-2" style={{ letterSpacing: "0.08em" }}>Paso 5</p>
                    <div className="card border rounded-3 p-3 mb-4">
                        <div className="d-flex align-items-center gap-2 mb-3">
                            <h6 className="fw-bold mb-0">Preguntas frecuentes</h6>
                            <small className="text-muted">(opcional, máx. 5)</small>
                            {faqEdit.length < 5 && (
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm rounded-3 ms-auto"
                                    onClick={() => setFaqEdit(prev => [...prev, { pregunta: "", respuesta: "" }])}
                                >
                                    <i className="bi bi-plus me-1"></i>Agregar pregunta
                                </button>
                            )}
                        </div>
                        <div className="d-flex flex-column gap-3">
                            {faqEdit.map((f, i) => (
                                <div key={i} className="border rounded-3 p-3">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <span className="text-muted small fw-semibold">Pregunta {i + 1}</span>
                                        {faqEdit.length > 1 && (
                                            <button
                                                type="button"
                                                className="btn btn-link btn-sm text-danger p-0"
                                                onClick={() => setFaqEdit(prev => prev.filter((_, j) => j !== i))}
                                            >
                                                <i className="bi bi-trash3"></i>
                                            </button>
                                        )}
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm rounded-3 mb-2"
                                        value={f.pregunta}
                                        onChange={e => setFaqEdit(prev => prev.map((x, j) => j === i ? { ...x, pregunta: e.target.value } : x))}
                                        placeholder="¿Cuánto tiempo tarda la entrega?"
                                    />
                                    <textarea
                                        className="form-control form-control-sm rounded-3"
                                        rows={2}
                                        value={f.respuesta}
                                        onChange={e => setFaqEdit(prev => prev.map((x, j) => j === i ? { ...x, respuesta: e.target.value } : x))}
                                        placeholder="La entrega depende del paquete elegido..."
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Botones guardar + publicar */}
                    <div className="d-flex flex-wrap gap-3 align-items-center mt-2">
                        <button
                            className="btn btn-dark rounded-3 px-4 py-2 fw-semibold"
                            onClick={guardarEdicion}
                            disabled={guardando || publicando}
                        >
                            {guardando
                                ? <><span className="spinner-border spinner-border-sm me-2" role="status" />Guardando...</>
                                : <><i className="bi bi-floppy me-2"></i>Guardar cambios</>
                            }
                        </button>
                        <button
                            className="btn btn-success rounded-3 px-4 py-2 fw-semibold"
                            onClick={publicarServicioAdmin}
                            disabled={guardando || publicando}
                        >
                            {publicando
                                ? <><span className="spinner-border spinner-border-sm me-2" role="status" />Publicando...</>
                                : <><i className="bi bi-send-check me-2"></i>Publicar servicio</>
                            }
                        </button>
                    </div>
                </div>
            )}
            {mostrarModalWhatsapp && (
                <ModalWhatsapp
                    proveedor={proveedor}
                    servicio={servicio}
                    adminNombre={[usuario?.nombre, usuario?.apellido].filter(v => v && v !== "NA").join(" ") || usuario?.username || ""}
                    onCerrar={() => setMostrarModalWhatsapp(false)}
                />
            )}

            {/* LIGHTBOX: ver imagen completa */}
            {imagenExpandida && (
                <div
                    onClick={() => setImagenExpandida(null)}
                    style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(var(--negro-rgb), 0.9)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', cursor: 'zoom-out' }}
                >
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); setImagenExpandida(null); }}
                        title="Cerrar"
                        style={{ position: 'absolute', top: 16, right: 16, width: 36, height: 36, borderRadius: '50%', border: 'none', backgroundColor: 'rgba(var(--blanco-rgb), 0.15)', color: 'var(--blanco)', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <i className="bi bi-x-lg"></i>
                    </button>
                    <img
                        src={imagenExpandida}
                        alt="Vista completa"
                        onClick={(e) => e.stopPropagation()}
                        style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: 8 }}
                    />
                </div>
            )}
        </div>
    );
}

export default ServicioAdminIndividual;
